import axios from "axios";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import {
  sendPolicyCallback,
  sendPolicyCallbackB,
} from "../../actions/dmiActions";

const PaymentLoading = () => {
  const navigate = useNavigate();

  // Fetch the id from the URL — same id used on the form page
  const searchParams = new URLSearchParams(window.location.search);
  const userIdFromUrl =
    searchParams.get("userId") ||
    searchParams.get("UserId") ||
    sessionStorage.getItem("userId") ||
    localStorage.getItem("userId");
  const ClientUserId =
    sessionStorage.getItem("userIdbyClient") ||
    localStorage.getItem("userIdbyClient");
  // console.log("User iddddddd : ", ClientUserId);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const MAX_ATTEMPTS = 5;
    const POLL_INTERVAL = 2000;
    let attempts = 0;
    let timeoutId;

    const getDmiPaymentResponseApi = async () => {
      attempts += 1;
      try {
        const res = await axios(
          `https://portal.acrossassist.com//api/partner/v1/dmi/GetPaymentStatusByUserId?UserId=${userIdFromUrl}&clinetUserId=${ClientUserId}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          },
        );

        // console.log("response : ", res);

        const orderStatus = res?.data?.data?.order_status;
        const rootStatus = res?.data?.status;
        // console.log("order status ", orderStatus);
        // console.log("Root status", rootStatus);
        // Success — order_status "Success" OR root status === true
        // if (orderStatus === "Success" || rootStatus === true) { old logic
        if (orderStatus === "Success") {
          const imei =
            sessionStorage.getItem("paymentImei") ||
            localStorage.getItem("paymentImei") ||
            "";
          const userIdbyClient =
            sessionStorage.getItem("userIdbyClient") ||
            localStorage.getItem("userIdbyClient") ||
            " ";
          const planName =
            sessionStorage.getItem("paymentPlanName") ||
            localStorage.getItem("paymentPlanName") ||
            "";

          // Call policy-callback only on successful payment
          try {
            // if (userIdbyClient == "mjuw") {
            const payload = {
              id: userIdbyClient,
              imei,
              plan_name: planName,
            };

            await Promise.all([
              sendPolicyCallback(payload),
              sendPolicyCallbackB(payload),
            ]);
            // }
          } catch (err) {
            console.error("policy-callback failed:", err);
            // silent — don't block navigation
          } finally {
            sessionStorage.removeItem("paymentImei");
            sessionStorage.removeItem("paymentPlanName");
            localStorage.removeItem("paymentImei");
            localStorage.removeItem("paymentPlanName");
            sessionStorage.removeItem("userIdbyClient");
            localStorage.removeItem("userIdbyClient");
          }

          navigate("/payment-success");
          return;
        }

        if (attempts < MAX_ATTEMPTS) {
          timeoutId = setTimeout(getDmiPaymentResponseApi, POLL_INTERVAL);
        } else {
          toast.error(res?.data?.status_message);
          navigate("/payment-failure");
        }
      } catch {
        if (attempts < MAX_ATTEMPTS) {
          timeoutId = setTimeout(getDmiPaymentResponseApi, POLL_INTERVAL);
        } else {
          navigate("/payment-failure");
        }
      }
    };

    getDmiPaymentResponseApi();

    return () => clearTimeout(timeoutId);
  }, [userIdFromUrl, navigate]);

  return (
    <Container
      fluid
      className="d-flex vh-100 justify-content-center align-items-center bg-light"
    >
      <Row>
        <Col xs={12} className="text-center">
          <Spinner
            role="status"
            variant="primary"
            animation="border"
            style={{ width: "4rem", height: "4rem" }}
          />
          <h3 className="mt-4">Processing Your Payment...</h3>
          <p className="text-muted">Please do not refresh the page.</p>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentLoading;
